export default __webpack_public_path__ + "static/media/sanjoy.eff48f12.jpg";